import React, { useState } from 'react';
import axios from 'axios';

// SCRUM-448: shown app-wide when the Jira connection needs re-authorization
// (HTTP 409 reason "reauth_required"). One click restarts the OAuth flow.
export default function ReconnectBanner({ onDismiss }) {
  const [error, setError] = useState(null);

  const handleReconnect = async () => {
    setError(null);
    try {
      const res = await axios.get('/api/oauth/jira/authorize');
      window.location.href = res.data.auth_url;
    } catch (e) {
      // Same failure message as Configuration's handleConnectJira; leave the
      // banner up so the user can retry.
      setError('Failed to initiate Jira connection');
    }
  };

  return (
    <div className="bg-[#F59E0B] text-[#0D1B2A] px-4 py-2 flex items-center justify-center gap-4 text-sm font-medium shrink-0">
      <span>Your Jira connection needs reconnecting to keep your data up to date.</span>
      {error && <span role="alert" className="font-semibold underline decoration-2">{error}</span>}
      <button
        type="button"
        onClick={handleReconnect}
        className="bg-[#0D1B2A] text-white px-4 py-1 rounded-md font-semibold hover:bg-[#1A2E45] transition-colors"
      >
        Reconnect Jira
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="text-[#0D1B2A] hover:opacity-70 font-bold text-lg leading-none"
      >
        ×
      </button>
    </div>
  );
}
